var map = {
	"./app.json": 553,
	"./blog.json": 554,
	"./components.json": 555,
	"./conversionTable.json": 556,
	"./currency.json": 557,
	"./currencyBRL.json": 558,
	"./currencyUSD.json": 559,
	"./cxi-old.json": 560,
	"./cxi.json": 561,
	"./events.json": 562,
	"./form.json": 563,
	"./glossary.json": 564,
	"./home.json": 565,
	"./iframe.json": 566,
	"./login.json": 567,
	"./logout.json": 568,
	"./matches.json": 569,
	"./menu.json": 570,
	"./news.json": 571,
	"./notifications.json": 572,
	"./oiweek.json": 573,
	"./pages.json": 574,
	"./profile.json": 575,
	"./ranking-BKP.json": 576,
	"./ranking.json": 577,
	"./register.json": 578,
	"./startup-cxi.json": 579,
	"./startup.json": 580,
	"./startupId.json": 581,
	"./subscription.json": 582,
	"./support.json": 583,
	"./translation.json": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;